import { render, staticRenderFns } from "./PurchaseOrderRK.vue?vue&type=template&id=13f33a21&scoped=true&"
import script from "./PurchaseOrderRK.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderRK.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderRK.vue?vue&type=style&index=0&id=13f33a21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f33a21",
  null
  
)

export default component.exports